<p-listbox [options]="employes" [(ngModel)]="selection" optionLabel="prenom" [scrollHeight]="'50vh'"
	[filterFields]="['prenom', 'nom', 'noEmploye']" filter="true" virtualScroll [virtualScrollItemSize]="40"
	[style]="{ width: '100%' }">

	<ng-template let-employe pTemplate="item">
		<div class="flex align-items-center gap-2">
			<i class="pi pi-user"></i>
			<div class="flex flex-column gap-1">
				<div class="font-bold">{{employe.prenom}} {{employe.nom}}</div>
				<div class="text-sm">{{employe.noEmploye}}</div>
			</div>
		</div>
	</ng-template>
</p-listbox>
<div class="flex justify-content-end gap-2 mt-2">
	<button pButton pRipple label="Confirmer" icon="pi pi-check" class="p-button-primary" [disabled]="!selection"
		(click)="Envoyer()"></button>
	<button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text" (click)="Annuler()"></button>
</div>